/*
 * Copyright (c) Dito Technologies
 */

import React from "react"
import styles from "./Stepper.module.scss";

import StepperItem, {Props as StepperItemProps} from "./StepperItem"

interface Props {
    stepClicked: (idx: number) => void,
    items: StepperItemProps[];
}

const Stepper: React.FC<Props> = ({items, stepClicked}) => {
    const steps = React.useMemo(() =>
            items.map((item, idx) => (
                <div className={styles.stepperItemAndLine} key={item.title + item.description}>
                    {idx !== 0 && <div className={styles.connectingLine}/>}
                    <div onClick={() => stepClicked(idx)}>
                        <StepperItem {...item} />
                    </div>
                </div>
            ))
        , [items, stepClicked])
    return (
        <div className={styles.container}>
            {steps}
        </div>
    )
}

export default Stepper;